/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $S3PutObjectUrl = {
  properties: {
    upload_url: {
      type: 'string',
      description: `s3 put object url`,
      isRequired: true,
    },
  },
} as const;
